<script setup>
const props = defineProps([
	"to",
	"hash",
	"href",
	"disabled",
	"processing",
	"iconLeft",
	"icon",
	"iconRight",
	"target",
]);
</script>

<template>
	<router-link v-if="to" class="button group" :disabled :to>
		<slot />
	</router-link>
	<component
		v-else
		:is="href ? 'a' : 'button'"
		class="button group"
		:disabled="disabled"
		:target="href ? (target ?? '_blank') : null"
		:href
	>
		<div class="relative isolate flex h-12 flex-col overflow-hidden">
			<span
				class="leading-[0.8] transition-transform duration-[400ms] group-hover:-translate-y-full"
			>
				<slot />
			</span>
			<span
				class="leading-[0.8] transition-transform duration-[400ms] group-hover:-translate-y-full"
				aria-hidden="true"
			>
				<slot />
			</span>
		</div>
	</component>
</template>
